<template>
  <div class="h-full p-20px">
    <div class="flex flex-column h-full">
      <vxe-toolbar class-name="px-16px" :loading="loading">
        <template #buttons>
          <DropdownCustom ref="paramsDropdown" button class="h-btn-primary" trigger="click">
            <div>{{ manba(params.entryDate).format('YYYY年MM月') }}</div>
            <template #content>
              <Form style="padding: 10px">
                <FormItem class="!pb-5px" label="工资月份">
                  <Select :datas="checkoutSelect" filterable v-model="params.entryDate" :deletable="false"/>
                </FormItem>
                <FormItem class="!pb-5px" label="部门">
                  <Select :datas="deptOptions" filterable v-model="params.deptId"/>
                </FormItem>
                <FormItem class="!pb-5px" label="姓名">
                  <Input v-model="params.name"/>
                </FormItem>
                <FormItem class="!pb-5px">
                  <vxe-button status="primary" @click="loadList();" :loading="loading">确定</vxe-button>
                  <vxe-button @click="this.$refs.paramsDropdown.hide()">取消</vxe-button>
                  <vxe-button @click="reset">重置</vxe-button>
                </FormItem>
              </Form>
            </template>
          </DropdownCustom>
          <a style="cursor: pointer; margin-left: 20px; color: #1063e0" @click="setSalaryItem()" v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'">自定义工资项目</a>
        </template>
        <template #tools>
          <Checkbox v-model="showAll" @click="showAll ? loadSalaryFields() : ''" class="mr-16px">编辑、显示工资明细</Checkbox>
          <Button v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" @click="showPayroll=true">生成工资表</Button>
          <!-- <DropdownMenu
                  button
                  trigger="hover"
                  @clickItem="importJournal"
                  style="width: 102px; text-align: center"
                  :datas="{declarationImport:'个税申报表导入',templateImport:'模板导入'}">
            导入
          </DropdownMenu> -->
          <!-- <Button v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" @click="importSalary">模板导入</Button> -->
          <!-- <Button @click="sendPayslip">发送工资条</Button> -->
          <Button v-if="User.role!=='ViewBase' && User.role!=='ViewMajor' && User.role!=='ViewFlagship'" @click="batchDelete">删除</Button>
          <Button @click="exportJournal">导出</Button>
          <Button v-if="!showAll" @click="printList">打印列表</Button>
          <Button v-if="showAll" @click="printReceipt">打印工资条</Button>
          <!-- <Button @click="individualDeclaration">个税申报</Button> -->
          <!-- <DropdownMenu
                  button
                  trigger="hover"
                  @clickItem="batchClickItem"
                  :datas="{batchDelete:'删除',exportJournal:'导出',printList:'打印'}">
            更多操作
          </DropdownMenu> -->
        </template>
      </vxe-toolbar>
      <div class="flex-1 h-0px">
        <div style="width:100%; height: 100%; float: left">
          <vxe-table ref="journalTableOne"
                     :checkbox-config="{visibleMethod:({ row }) => !row.init,checkMethod:({ row }) => !row.init}"
                     :loading="loading"
                     :data="dataResult.results"
                     height="auto"
                     align="center"
                     v-if="!showAll"
                     border>
            <vxe-column type="checkbox" width="5%" align="center" fixed="left"/>
            <vxe-column title="编号" field="code" width="8%"/>
            <vxe-column title="姓名" field="name" width="12%"/>
            <vxe-column title="部门" field="departmentId" width="12%">
              <template #default="{row}">
                {{deptNameFormat(row.departmentId)}}
              </template>
            </vxe-column>
            <!-- <vxe-column title="手机号" field="telPhone" width="160"/> -->
            <!-- <vxe-column title="身份证号" field="idCard" width="160"/> -->
            <vxe-column title="工资总额" field="totalAmount" width="9%"/>
            <vxe-column title="应扣工资" field="deductAmount" width="9%"/>
            <vxe-column title="应发工资" field="payableAmount" width="9%"/>
            <vxe-column title="代扣个人款项" field="withholdingAmount" width="9%"/>
            <vxe-column title="实发工资" field="realPayAmount" width="9%"/>
            <vxe-column title="公司承担款项" field="enterpriseAmount" width="9%"/>
            <vxe-column title="员工成本合计" field="empCostSum" width="9%"/>
          </vxe-table>


          <vxe-table
                  ref="journalTableTwo"
                  :checkbox-config="{visibleMethod:({ row }) => !row.init,checkMethod:({ row }) => !row.init}"
                  :loading="loading"
                  :data="dataResult.results"
                  height="auto"
                  :print-config="{}"
                  align="center"
                  :edit-config="{trigger: 'click', mode: 'row', showIcon: false}"
                  @edit-closed="saveSalaryChange"
                  v-if="showAll"
                  border>
            <vxe-column type="checkbox" width="50" align="center" fixed="left"/>
            <vxe-column title="编号" field="code" width="50" fixed="left"/>
            <vxe-column title="姓名" field="name" width="100" fixed="left"/>
            <vxe-column title="部门" field="departmentId" width="120">
              <template #default="{row}">
                {{deptNameFormat(row.departmentId)}}
              </template>
            </vxe-column>
            <vxe-column title="手机号" field="telPhone" width="120"/>
            <vxe-column title="身份证号" field="idCard" width="160"/>
            <vxe-colgroup title="工资总额" field="totalSalaryColumn">
              <vxe-column
                      v-for="(config, index) in addSalaryFields"
                      :field="config.id"
                      :key="index"
                      :title="config.fieldName"
                      :width="100"
                      :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column }">
                  <vxe-input v-model="row[config.id]" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
            </vxe-colgroup>
            <vxe-colgroup title="应扣工资"> 
              <vxe-column
                      v-for="(config, index) in subSalaryFields"
                      :key="index"
                      :field="config.id"
                      :title="config.fieldName"
                      :width="100"
                      :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row[config.id]" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
            </vxe-colgroup>
            <vxe-column title="应发工资" field="payableAmount" width="100">
              <template #edit="{ row, column  }">
                {{row.payableAmount}}
              </template>
            </vxe-column>
            <vxe-colgroup title="代扣个人款项">
              <vxe-column
                  v-for="(config, index) in insureList"
                  :field="'P_'+config.id"
                  :key="index"
                  :title="config.name"
                  :width="100"
                  :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['P_'+config.id]" disabled :controls="false" type="number"></vxe-input>
                </template>
<!--                <template #default="{ row  }">
                  {{matchSocialVal(row,config,2)}}
                </template>-->
              </vxe-column>
              <vxe-column title="代扣个人款项小计" field="withholdingAmount" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  {{row.withholdingAmount}}
                </template>
              </vxe-column>
            </vxe-colgroup>
            <vxe-column title="其他扣除" field="otherDeductAmount" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['otherDeductAmount']" :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column title="累计收入额" field="incomeSum" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['incomeSum']" :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column title="累计减除费用" field="deductSum" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['deductSum']" :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column title="累计代扣额" field="withholdingSum" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['withholdingSum']" :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-colgroup title="累计专项附件扣除">
              <vxe-column title="子女教育" field="specialChildEdu" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['specialChildEdu']" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column title="赡养老人" field="specialParent" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['specialParent']" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column title="住房贷款利息" field="specialHouseLoans" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['specialHouseLoans']" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column title="住房租金" field="specialHouseRent" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['specialHouseRent']" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column title="继续教育" field="specialContinuingEdu" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['specialContinuingEdu']" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column title="3岁以下婴幼儿照护" field="specialInfantCare" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['specialInfantCare']" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column title="大病医疗" field="specialSerious" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['specialSerious']" :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column title="累计专项附加扣除小计" field="specialSubTotal" width="100">
                <template #edit="{ row, column  }">
                  {{row.specialSubTotal}}
                </template>
              </vxe-column>
            </vxe-colgroup>
<!--            <vxe-column title="累计专项附加扣除" field="specialSum" width="160" :edit-render="{autofocus: '.vxe-input&#45;&#45;inner'}">-->
<!--              <template #edit="{ row, column  }">-->
<!--                <vxe-input v-model="row['specialSum']" :controls="false" type="number"></vxe-input>-->
<!--              </template>-->
<!--            </vxe-column>-->
            <vxe-column title="累计其他扣除" field="otherDeductSum" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['otherDeductSum']" :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column title="累计应缴个税" field="payableTaxSum" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['payableTaxSum']" disabled :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column title="已缴个税" field="paidTaxSum" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['paidTaxSum']" :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column title="本月应缴个税" field="payableTaxAmount" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['payableTaxAmount']" disabled :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-column title="实发工资" field="realPayAmount" width="100" :edit-render="{autofocus: '.vxe-input--inner'}">
              <template #edit="{ row, column  }">
                <vxe-input v-model="row['realPayAmount']" :controls="false" type="number"></vxe-input>
              </template>
            </vxe-column>
            <vxe-colgroup title="公司承担款项" field="insureList">
              <vxe-column
                  v-for="(config, index) in insureList"
                  :field="'C_'+config.id"
                  :key="index"
                  :title="config.name"
                  :width="100"
                  :edit-render="{autofocus: '.vxe-input--inner'}">
                <template #edit="{ row, column  }">
                  <vxe-input v-model="row['C_'+config.id]" disabled :controls="false" type="number"></vxe-input>
                </template>
              </vxe-column>
              <vxe-column title="公司承担款项小计" field="enterpriseAmount" width="100">
                <template #edit="{ row, column  }">
                  {{row.enterpriseAmount}}
                </template>
              </vxe-column>
            </vxe-colgroup>
            <vxe-column title="员工成本合计" field="empCostSum" width="100" :edit-render="{}">
              <template #edit="{ row }">
                <vxe-input v-model="row.empCostSum" type="text"></vxe-input>
              </template>
            </vxe-column>
          </vxe-table>
        </div>
        <!-- <div style="width: 6%; float: right; margin-top: 20px">
          <i v-if="ShowMonthList" class="vxe-icon-arrow-double-left" style="float: left" @click="chooseMonthType(false)"></i>
          <i v-else class="vxe-icon-arrow-double-right" style="float: left" @click="chooseMonthType(true)"></i>
          <div class="monthDateCont" v-if="ShowMonthList">
            <div class="monthDateBox singleDate">
              <div class="monthPick monthPickStart">{{ manba(params.entryDate).format('YYYY-MM') }}</div>
            </div>
            <ul class="monthList">
              <li v-if="monthStart !== 0"><a class="monthItem prev_btn" @click="updateMonth(true)"><i class="vxe-icon-arrow-up"></i></a></li>
              <li v-else><a class="monthItem prev_btn prev_disabled_btn"><i class="vxe-icon-arrow-up"></i></a></li>
              <li v-for="(item, index) in monthDataList.results.slice(monthStart, monthEnd)">
                <a v-if="item.substring(5) !== '1' && item === monthDataList.nowDate" class="monthItem active">{{ item.substring(5) + '月' }}</a>
                <a v-else-if="item.substring(5) !== '1' && item !== monthDataList.nowDate" class="monthItem" @click="changeMonth(index)">{{ item.substring(5) + '月' }}</a>
                <a v-else class="monthItem" @click="changeMonth(index)">{{ item.substring(5) + '月' }}<span class="year">{{ item.substring(0, 4) }}</span></a>
              </li>
              <li v-if="monthEnd !== monthDataList.results.length"><a class="monthItem prev_btn" @click="updateMonth(false)"><i class="vxe-icon-arrow-down"></i></a></li>
              <li v-else><a class="monthItem prev_btn prev_disabled_btn"><i class="vxe-icon-arrow-down"></i></a></li>
            </ul>
          </div>
        </div> -->
      </div>
      <vxe-pager @page-change="onPageChange"
                 v-model:current-page="page.page"
                 v-model:page-size="page.pageSize"
                 :total="dataResult.total"
                 :layouts="['PrevJump', 'PrevPage', 'Number', 'NextPage', 'NextJump', 'Sizes', 'FullJump', 'Total']">
        <template #left>
          <vxe-button @click="loadList()" type="text" size="mini" icon="fa fa-refresh" :loading="loading"></vxe-button>
        </template>
      </vxe-pager>
    </div>
  </div>

  <!-- 生成工资表弹窗 -->
  <div>
    <Modal v-model="showPayroll">
      <div slot="header">生成工资表</div>
      <div style="margin-top: 30px"><Radio v-model="generatePayrollType" :datas="generatePayrollTypes" ></Radio></div>
      <div slot="footer" class="h-modal-footer" style="margin-top: 30px">
        <button class="h-btn" @click="showPayroll=false">取消</button>
        <button class="h-btn h-btn-blue" @click="generatePayroll">确定</button>
      </div>
    </Modal>
  </div>

</template>

<script>


  import {mapGetters, mapState} from "vuex";

 /**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2019-2020金华企客观网络科技有限公司All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2020年08月08日</li>
 * <li>@author     : ____′↘企万慧</li>
 * </ul>
 * <p>****************************************************************************</p>
 */

  export default {
    name: "SalaryManagement",
    computed: {
      ...mapState(['currentAccountSets','User']),
      ...mapGetters(['checkoutSelect', 'localCurrency']),
      deptListMap() {
        let map = {};
        this.deptList.map(val => {
          map[val.key] = val.title;
        })
        return map;
      },
    },
    mounted() {
    // 在组件挂载后打印 checkoutSelect 的值
      console.log(this.checkoutSelect);
    },
  }
</script>
<script setup>
  import {ref, h, watch, reactive} from "vue";
  import manba from "manba";
  import {confirm, message} from "heyui.ext";
  import {useStore} from 'vuex'
  import SalaryManage from "@/api/SalaryManage";
  import SalaryFieldForm from "@/views/salary/SalaryFieldForm";
  import setting from "@/api/setting";
  import Qs from "qs";
  import {layer} from "@layui/layer-vue";
  import InsuredConfig from "../../api/InsuredConfig";
  import SalaryImport from "@/views//salary/SalaryImport"

  const store = useStore();

  const deptOptions = ref([]);
  const account = ref(null);
  const journalTableOne = ref(null);
  const journalTableTwo = ref(null);
  const paramsDropdown = ref(null);
  const loading = ref(false);

  const currentAccountDate = manba(store.state.currentAccountSets.currentAccountDate);
  const entryDate = ref(currentAccountDate.startOf(manba.MONTH).format("YYYY-M"));

  const updating = ref(false);
  const showAll = ref(false);
  const showPayroll = ref(false);
  const generatePayrollTypes = ref({ 1: '生成基础数据', 2: '生成空白记录'});
  const generatePayrollType = ref(1);



  const addSalaryFields = ref([]);
  const subSalaryFields = ref([]);
  const loadSalaryFields = () => {
    SalaryManage.listSalaryFields().then(({data}) => {
      let addFields = data.filter(item=>item.fieldType==="ADD");
      let subFields = data.filter(item=>item.fieldType==="SUB");
      addSalaryFields.value = addFields || ['工资']
      subSalaryFields.value = subFields || []
    })
  }
  loadSalaryFields();

  //社保配置
  const insureList = ref([]);
  const loadInsuredConfig = () =>{
    InsuredConfig.list({}).then(res=>{
      insureList.value = res.data;
    })
  }
  loadInsuredConfig();

  const matchSocialVal = (row,social,type) =>{
    if (!row.socialList) {
      return "";
    }

    let idx = row.socialList.findIndex(item=>item.insureDetailId==social.id);
    if (idx===-1) {
      return ""
    }
    if (type===1) {
      return row.socialList[idx].enterpriseAmount;
    }
    return row.socialList[idx].personalAmount;
  }
  const ShowMonthList = ref(true);
  const monthDataList = ref({
    results: [],
    nowDate: null
  });
  const monthStart = ref(0);
  const monthEnd = ref(12);

  const page = ref({
    page: 1,
    pageSize: 20
  })

  const dataResult = ref({
    results: [],
    totalSalaryColumn: [],
    deductibleSalaryColumn: [],
    actualSalaryColumn: [],
    total: 20
  })

  const dataResultOriginal = ref([])//存放每次表格内修改之前的数据

  const params = reactive({
    entryDate: entryDate,
    deptId: null,
    name: null
  });

  const reset = () => {
    // params.value = {
    //   entryDate: entryDate,
    //   deptId: null,
    //   name: null
    // };
    params.deptId = null;
    params.name = null;
    // loadList();
  }

  const onPageChange = ({currentPage, pageSize}) => {
    page.value.page = currentPage;
    page.value.pageSize = pageSize;
    loadList();
  }

  const setSalaryItem = () => {
    let layerId = layer.drawer({
      title: "自定义工资项目",
      shadeClose: false,
      closeBtn: false,
      zIndex: 1000,
      area: ['800px', '100vh'],
      content: h(SalaryFieldForm, {
        onClose: () => {
          layer.close(layerId);
          loadList();
        },
        onSuccess: () => {
          loadList();
          layer.close(layerId);
        }
      })
    });
  }

  setting.accountingCategoryDetails.loadAuxiliaryAccountingDataByName(['DEPARTMENT', 'VENDOR']).then(({data}) => {
    deptOptions.value = data['DEPARTMENT'].map(val => {
      return {
        key: val.id,
        accountingCategoryId: val.categoryId,
        title: val.name
      }
    });
  })

  const deptNameFormat = (deptId) =>{
    let idx = deptOptions.value.findIndex(dept=>dept.key===deptId);
    if (idx>-1) {
      return deptOptions.value[idx].title
    }
  }


  const loadList = () => {
    loading.value = true
    SalaryManage.list(Object.assign({}, params, page.value)).then(({data}) => {
      // dataResult.value = data;
      data.results.forEach(row=>{
        //社保
        if (row.socialList && row.socialList.length>0) {
          row.socialList.forEach(social=>{
            row["C_"+social.insureDetailId] = social.enterpriseAmount
            row["P_"+social.insureDetailId] = social.personalAmount
          })
        }
        //工资项
        if (row.addFieldValues && row.addFieldValues.length>0) {
          row.addFieldValues.forEach(field=>{
            row[field.fieldId] = field.value
          })
        }

        //扣减项
        if (row.subFieldValues && row.subFieldValues.length>0) {
          row.subFieldValues.forEach(field=>{
            row[field.fieldId] = field.value
          })
        }
      })
      dataResult.value.results = data.results.map(item=>{return {...item,totalSalaryColumn:addSalaryFields.value}})
      dataResult.value.total = data.total;
      dataResult.value.totalPage = data.totalPage;
      dataResultOriginal.value = JSON.parse(JSON.stringify(dataResult.value.results));//每次表格内修改之前的数据比如说修改了工资，这是存的修改前的数据
      paramsDropdown.value.hide();
    }).finally(() => loading.value = false)
  }
  loadList();

  const calcTotal = ({columns, data}) => {
    const row = [];
    columns.forEach(col => {
      if ('code2' === col.property) {
        // row.push(this.numFormat((total, r) => total + (r.code2 || 0), 0));
      } else if ('code3' === col.property) {
        // row.push(this.numFormat(this.topData.filter(val => val.balanceDirection === '贷').reduce((total, r) => total + (r.beginBalance || 0), 0)));
      } else {
        row.push(col.property === "deptName" ? '合计' : "")
      }
    })
    return [row];
  }

  // 是否显示月份列表
  const chooseMonthType = (result) => {
    ShowMonthList.value = result
  }

  // 查询月份列表接口
  const queryMonthList = () => {
    // SalaryManage.queryMonthList().then(() => {
    // }).finally()
    monthDataList.value = {
      results: ['2022-5', '2022-6', '2022-7', '2022-8', '2022-9', '2022-10', '2022-11', '2022-12', '2023-1', '2023-2', '2023-3', '2023-4', '2023-5', '2023-6', '2023-7', '2023-8'],
      nowDate: '2023-7'
    }
    monthStart.value = monthDataList.value.results.length - 13
    monthEnd.value = monthDataList.value.results.length - 1
  }
  queryMonthList()

  // 改变月份
  const updateMonth = (result) => {
    if (result) {
      monthStart.value = monthStart.value - 1
      monthEnd.value = monthEnd.value - 1
    } else {
      monthStart.value = monthStart.value + 1
      monthEnd.value = monthEnd.value + 1
    }
  }
 // 改变月份
  const changeMonth = (result) => {
    monthDataList.value.nowDate = monthDataList.value.results.slice(monthStart.value, monthEnd.value)[result]
    entryDate.value = monthDataList.value.nowDate
    loadList()
  }

  const getRowSocialTotal = (row,type)=>{
    if (type===1) {
      //1是企业
      let valArr = insureList.value.map(item=>row["C_"+item.id]).filter(it=>it);
      if (valArr && valArr.length>0) {
        return valArr.reduce((pre, next)=>Number(pre)+Number(next),0);
      }
    }else if (type===2) {
      //2是个人
      let valArr = insureList.value.map(item=>row["P_"+item.id]).filter(it=>it);
      if (valArr && valArr.length>0) {
        return valArr.reduce((pre, next)=>Number(pre)+Number(next),0);
      }
    }
    return 0;
  }

  const buildSocialValParam = (row,type)=>{
    //字段格式 {empSocialId,socialId,socialName,amount}
    if (type===1) {
      //1是企业,
      let valArr = insureList.value.map(item=>{
        let val = row["C_"+item.id];
        if(!val) val = 0;
        return {empSocialId:"",socialId:item.id,socialName:item.name,amount:val}
      });
      return valArr;

    }else if (type===2) {
      //2是个人
      let valArr = insureList.value.map(item=>{
        let val = row["P_"+item.id];
        if(!val) val = 0;
        return {empSocialId:"",socialId:item.id,socialName:item.name,amount:val}
      });
      return valArr;
    }
    return [];
  }

  const buildFieldValParam = (row,type)=>{
    //字段格式 {fieldId,fieldName,value}
    if (type===1) {
      //1是增加项,
      let valArr = addSalaryFields.value.map(item=>{
        let val = row[item.id];
        if(!val) val = 0;
        return {fieldId:item.id,fieldName:item.fieldName,value:val}
      });
      return valArr;

    }else if (type===2) {
      //2是扣减
      let valArr = subSalaryFields.value.map(item=>{
        let val = row[item.id];
        if(!val) val = 0;
        return {fieldId:item.id,fieldName:item.fieldName,value:val}
      });
      return valArr;
    }
    return [];
  }

  const calcSpecialAmt = (row)=>{
    let init = Number(0);
    if(row.specialChildEdu) init+=Number(row.specialChildEdu)
    if(row.specialParent) init+=Number(row.specialParent)
    if(row.specialHouseLoans) init+=Number(row.specialHouseLoans)
    if(row.specialHouseRent) init+=Number(row.specialHouseRent)
    if(row.specialContinuingEdu) init+=Number(row.specialContinuingEdu)
    if(row.specialInfantCare) init+=Number(row.specialInfantCare)
    if(row.specialSerious) init+=Number(row.specialSerious)
    return init.toFixed(2);
  }
  // 编辑数据接口
  const saveSalaryChange = ({ row, column }) => {
    console.log(row,dataResultOriginal.value);
    const field = column.field
    //计算工资
    // console.log("row",row)
    let addVals = addSalaryFields.value.map(salary=>{return row[salary.id]}).filter(item=> item);
    if (addVals && addVals.length>0) {
      row.totalAmount = addVals.reduce((pre,next)=> Number(pre) + Number(next),0)
    }else {
      row.totalAmount = 0;
    }

    //应扣工资
    let subVals = subSalaryFields.value.map(salary=>{return row[salary.id]}).filter(item=> item);
    if (subVals && subVals.length>0) {
      row.deductAmount = subVals.reduce((pre,next)=> Number(pre) + Number(next),0)
    }else {
      row.deductAmount = 0;
    }

    //拼装自定义字段参数
    let addFieldValues = buildFieldValParam(row,1);
    let subFieldValues = buildFieldValParam(row,2);
    row.addFieldValues = addFieldValues;
    row.subFieldValues = subFieldValues;

    //应发工资 = 总工资-应扣工资
    row.payableAmount = (row.totalAmount-row.deductAmount).toFixed(2)

    //累计收入
    let incomeSumOriginal = dataResultOriginal.value.find(item=>item.id===row.id).incomeSum;//上次累计收入
    let payableAmountOriginal = dataResultOriginal.value.find(item=>item.id===row.id).payableAmount;//上次应发工资
    //两次应发工资不同，才会执行这个
    if(payableAmountOriginal != row.payableAmount){
      row.incomeSum = row.payableAmount - Number(payableAmountOriginal) + Number(incomeSumOriginal);//本次应发工资-上次应发工资 就是两次应发工资的差异，加上上次累计收入就是本次累计收入
    }

    //累计其他扣除
    let otherDeductSumOriginal = dataResultOriginal.value.find(item=>item.id===row.id).otherDeductSum;//上次累计收入
    let otherDeductAmountOriginal = dataResultOriginal.value.find(item=>item.id===row.id).otherDeductAmount;//上次其他扣除
    //两次应发工资不同，才会执行这个
    if(otherDeductAmountOriginal != row.otherDeductAmount){
      row.otherDeductSum = row.otherDeductAmount - Number(otherDeductAmountOriginal) + Number(otherDeductSumOriginal);//本次其他扣除-上次其他扣除 就是两次应发工资的差异，加上上次累计扣除就是本次累计扣除
    }

    //代扣款项金额
    let enterpriseAmount = getRowSocialTotal(row,1);
    row.enterpriseAmount = enterpriseAmount.toFixed(2)
    //公司承担款项
    let personalAmount = getRowSocialTotal(row,2);
    row.withholdingAmount = personalAmount.toFixed(2)


    //拼装社保相关字段enterpriseSocialValues,personalSocialValues{empSocialId,socialId,socialName,amount}
    row.enterpriseSocialValues = buildSocialValParam(row,1)
    row.personalSocialValues = buildSocialValParam(row,2)


    //专项附加扣除计算
    let specialAmt = calcSpecialAmt(row)
    row.specialSubTotal = specialAmt;

    //免税扣除所有金额= 附加扣除金额 + 免税额(5000那个免税线) + 五险一金 + 其他扣除
    let subTotalAmt = Number(specialAmt) + Number(row.deductSum?row.deductSum:0) + Number(row.deductSum?row.deductSum:0)


    let empCostSum = Number(row.payableAmount)+Number(row.enterpriseAmount);
    row.empCostSum = empCostSum.toFixed(2)

    //payableTaxAmount 本月应交个税计算
    //payableTaxSum 累计应交个税
    let payableTaxSum = (Number(row.incomeSum) - Number(row.otherDeductSum) - Number(row.deductSum) - Number(row.withholdingSum) - Number(row.specialSubTotal)).toFixed(2)
    if(payableTaxSum <= 36000){
      payableTaxSum = (payableTaxSum * 0.03).toFixed(2);
    }else if(payableTaxSum > 36000 && payableTaxSum <= 144000){
      payableTaxSum = (payableTaxSum * 0.1).toFixed(2) - 2520;
    }else if(payableTaxSum > 144000 && payableTaxSum <= 300000){
      payableTaxSum = (payableTaxSum * 0.2).toFixed(2) - 16920;
    }else if(payableTaxSum > 300000 && payableTaxSum <= 420000){
      payableTaxSum = (payableTaxSum * 0.25).toFixed(2) - 31920;
    }else if(payableTaxSum > 420000 && payableTaxSum <= 660000){
      payableTaxSum = (payableTaxSum * 0.3).toFixed(2) - 52920;
    }else if(payableTaxSum > 660000 && payableTaxSum <= 960000){
      payableTaxSum = (payableTaxSum * 0.35).toFixed(2) - 85920;
    }else if(payableTaxSum > 960000){
      payableTaxSum = (payableTaxSum * 0.45).toFixed(2) - 181920;
    }
    row.payableTaxSum = payableTaxSum > 0 ? payableTaxSum : 0;
    row.payableTaxAmount = (row.payableTaxSum - row.paidTaxSum) > 0 ? (row.payableTaxSum - row.paidTaxSum).toFixed(2) : 0;

    //实发工资 = 应发工资-代扣金额 - 本月应交个税
    if(row.payableTaxAmount > 0){
      row.realPayAmount = (row.payableAmount-row.withholdingAmount-row.payableTaxAmount).toFixed(2)
    }else{
      row.realPayAmount = (row.payableAmount-row.withholdingAmount).toFixed(2)
    }
    //执行保存
    if (!row.id) {
      SalaryManage.saveSalary({...row,empId:row.employeeId}).then(res=>{
        message("保存成功~");
        loadList();
      });
    }else {
      SalaryManage.updateSalary({...row,empId:row.employeeId}).then(res=>{
        message("保存成功~");
        loadList();
      });
    }

  }

  const printClickItem = (key) => {
    window.open("/api/pdf/journal/list/" + account.value.id + "?" + Qs.stringify(Object.assign(params, page.value)))
  }

  //jxd导出
  const exportJournal = () => {
    if (!showAll.value) {
      const $table = journalTableOne.value
      loading.value = true
      SalaryManage.list(Object.assign({}, params, { page: 1, pageSize: 1000000 })).then(({ data }) => {
        console.log("data", data)
        // 预处理数据，将部门ID替换为部门名称
        const processedData = data.results.map((row) => ({
          ...row,
          departmentId: deptNameFormat(row.departmentId), // 将部门ID字段替换为部门名称
        }));
        // 定义需要导出的列，排除复选框列
        const exportColumns = [
          { field: 'code', title: '编号' },
          { field: 'name', title: '姓名' },
          { field: 'departmentId', title: '部门' }, // 使用预处理后的部门名称
          { field: 'telPhone', title: '手机号' },
          { field: 'idCard', title: '身份证号' },
          { field: 'totalAmount', title: '工资总额' },
          { field: 'deductAmount', title: '应扣工资' },
          { field: 'payableAmount', title: '应发工资' },
          { field: 'withholdingAmount', title: '代扣个人款项' },
          { field: 'realPayAmount', title: '实发工资' },
          { field: 'enterpriseAmount', title: '公司承担款项' },
          { field: 'empCostSum', title: '员工成本合计' },
        ];
        $table.exportData({
          filename: `${params.entryDate}工资表`,
          type: 'csv',
          isHeader: true,
          isFooter: true,
          data: processedData,
          columns: exportColumns,
        });
      }).finally(() => loading.value = false);
    }else{
      //journalTableOne
      const $table = journalTableTwo.value
      loading.value = true
      SalaryManage.list(Object.assign({}, params, page.value)).then(({data}) => {
        // 预处理数据，将部门ID替换为部门名称
        const processedData = data.results.map((row) => ({
          ...row,
          departmentId: deptNameFormat(row.departmentId), // 将部门ID字段替换为部门名称
        }));
        // dataResult.value = data;
        data.results.forEach(row=>{
          //社保
          if (row.socialList && row.socialList.length>0) {
            row.socialList.forEach(social=>{
              row["C_"+social.insureDetailId] = social.enterpriseAmount
              row["P_"+social.insureDetailId] = social.personalAmount
            })
          }
          //工资项
          if (row.addFieldValues && row.addFieldValues.length>0) {
            row.addFieldValues.forEach(field=>{
              row[field.fieldId] = field.value
            })
          }

          //扣减项
          if (row.subFieldValues && row.subFieldValues.length>0) {
            row.subFieldValues.forEach(field=>{
              row[field.fieldId] = field.value
            })
          }
        })
        $table.exportData({
          filename: `${params.entryDate}工资表`,
          type: 'csv',
          isHeader: true,
          isFooter: true,
          data: processedData
        })
      }).finally(() => loading.value = false)
    }
  }

  // 生成工资表
  const generatePayroll = () => {
    // showPayroll.value = true
    //generatePayrollType,1: 生成基础数据, 2:生成空白记录
    let value = generatePayrollType.value;
    SalaryManage.generateSalary({type:generatePayrollType.value,entryDate:params.entryDate}).then(res=>{
      // console.log("resssss",res)
      message("生成成功~");
      showPayroll.value=false
      loadList();
    })
    if (value===1) {
      //带基础数据

    }else if (value===2) {
      //空白
    }
  }

  // 导入接口
  const importSalary = (type) => {
    let layerId = layer.open({
		title: "工资导入",
		shadeClose: false,
		closeBtn: false,
		zIndex: 1000,
		area: ['500px', 'auto'],
		content: h(SalaryImport, {
			// account: account.value,
			// ioType: ioType.value,
			onClose: () => {
				loadList();
				layer.close(layerId);
			},
			onSuccess: () => {
				loadList();
				layer.close(layerId);
			}
		})
	});
  }

  // 发送工资条接口
  const sendPayslip = () => {

  }

  // 个税申报接口
  const individualDeclaration = () => {

  }

  //batchDelete
  const batchDelete = () => {
    let records;
    if(!showAll.value) {
      // journalTableOne
      records = journalTableOne.value.getCheckboxRecords().map(row => row.id);
    }else{
      // journalTableTwo
      records = journalTableTwo.value.getCheckboxRecords().map(row => row.id);
    }
    if (records.length) {
      confirm({
        content: `确认删除这些记录?`,
        onConfirm: () => {
          loading.value = true;
          SalaryManage.batchDelete(records,params.entryDate).then(() => {
            loadList();
          }).finally(() => loading.value = false)
        }
      })
    }else {
      message("请选择需要操作的记录~")
    }
  }

  const printList = () => {
    let topHtml = `
      <div style="text-align: left"><h3>${manba(params.entryDate).format('YYYY年MM月')}-工资表</h3></div>
      `
    let columns = [
      { field: 'code' },
      { field: 'name' },
      { field: 'departmentId' },
      { field: 'telPhone' },
      { field: 'idCard' },
      { field: 'totalAmount' },
      { field: 'deductAmount' },
      { field: 'payableAmount' },
      { field: 'withholdingAmount' },
      { field: 'realPayAmount' },
      { field: 'enterpriseAmount' },
      { field: 'empCostSum' },
    ];
    const $table = journalTableOne.value
    if ($table) {
      $table.print({
        // 打印指定列
        columns,
        // 打印之前拼接自定义模板
        beforePrintMethod: ({ content }) => {
          // 打印之前，返回自定义的 html 内容
          return topHtml + content
        }
      })
    }
  }

  const printReceipt = () => {
    const $table = journalTableTwo.value
    if ($table) {
      $table.openPrint()
    }
  }
  // 更多操作
  // const batchClickItem = (type) => {
  //   if(!showAll.value) {
  //     // journalTableOne
  //     let records = journalTableOne.value.getCheckboxRecords().map(row => row.id);
  //   }else{
  //     // journalTableTwo
  //     let records = journalTableTwo.value.getCheckboxRecords().map(row => row.id);
  //   }
  //   // let records = journalTable.value.getCheckboxRecords().map(row => row.id);
  //   console.log("选中记录",records)
  //   if (records.length) {
  //     switch (type) {
  //       case 'batchDelete':
  //         confirm({
  //           content: `确认删除这些记录?`,
  //           onConfirm: () => {
  //             loading.value = true;
  //             SalaryManage.batchDelete(records,params.entryDate).then(() => {
  //               loadList();
  //             }).finally(() => loading.value = false)
  //           }
  //         })
  //         break
  //       case 'exportJournal':
  //         exportJournal(records)
  //         break
  //       case 'printList':
  //         printClickItem()
  //         break
  //       case 'payrollRecord':
  //       case 'declarationRecord':
  //     }
  //   } else {
  //     message("请选择需要操作的记录~")
  //   }
  // }
</script>

<style lang="less" scoped>
  .monthDateCont {
    position: relative;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
    transition: all 0 ease 2s;
    float: right;
    width: 82%;
  }
  .monthDateBox {
    position: relative;
    padding: 5px 0;
    text-align: center;
    background-color: #f7f8ff;
    cursor: pointer;
    user-select: none;
  }
  .monthDateBox .monthPick {
    margin: 5px 3px;
    height: 24px;
    line-height: 24px;
    font-size: 12px;
    color: #000;
    border-radius: 5px;
    border: 1px solid #F2F2F2;
    background-color: #fff;
  }
  .monthList {
    text-align: center;
    background-color: #fff;
    /*padding: 10px 20px 10px 30px;*/
  }
  .monthList li a.prev_btn, .zmsunform-fie-ex_datev .monthList li a.next_btn {
    background-color: #2080f0;
    color: #fff;
    width: 20px;
    height: 20px;
    line-height: 20px;
    margin: 10px 0;
  }
  .monthList li a.prev_disabled_btn, .monthList li a.next_disabled_btn, .monthList li a.prev_disabled_btn:hover, .monthList li a.next_disabled_btn:hover {
    cursor: default;
    color: #bbb;
    background-color: transparent;
  }
  .monthList li a.active {
    color: #fff;
    background-color: #2080f0;
  }
  .monthList li a:hover {
    color: #fff;
    background-color: #2080f0;
  }
  .monthList li a {
    position: relative;
    display: inline-block;
    width: 28px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    color: #333;
    cursor: pointer;
    font-size: 12px;
    border-radius: 30px;
    user-select: none;
  }
  .monthList li a .year {
    position: absolute;
    left: -24px;
    top: 0px;
    -moz-border-radius: 5px;
    -webkit-border-radius: 5px;
    border-radius: 5px;
    display: inline-block;
    color: #fff;
    background-color: #2080f0;
    line-height: 8px;
    padding: 2px 3px;
  }
</style>
<!-- jxd这个vxetable的弹出窗里面的复选框样式有问题下面解决一下，尽量用多个class选中，防止影响其他的 -->
<style>
  .vxe-export--panel-option-row>.vxe-checkbox>.vxe-checkbox--icon{
    display: none;
  }
</style>
